import { GLOBAL_BANNER_COPY_120424 } from "@faire/web-api--source/indigofair/settings/GLOBAL_BANNER_COPY_120424";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";

import { useSetting } from "@faire/retailer/settings/__internal__/useSetting";

// This XP controls the copy of the global banner on the homepage
// isBannerlessVariant controls the bannerless variant
// isUnlockVariant controls the "Unlock Wholesale Pricing" variant
// isAnimatedVariant controls the animated variant that cycles through 3 different messages
export const useSettingGlobalBannerCopy = (): {
  isUnlockVariant: boolean;
  isBannerlessVariant: boolean;
  isAnimatedVariant: boolean;
} => {
  const setting = useSetting(
    GLOBAL_BANNER_COPY_120424,
    IFourVariantXP.Bucket.CONTROL
  );

  return {
    isBannerlessVariant: setting === IFourVariantXP.Bucket.VARIANT_2,
    isUnlockVariant: setting === IFourVariantXP.Bucket.VARIANT_3,
    isAnimatedVariant: setting === IFourVariantXP.Bucket.VARIANT_4,
  };
};
